// import React from "react";
// import ChatBot from "./ChatBot";

// import "../Styles/Clients.css"; // Assuming you save the CSS in a file named Clients.css

// function Clients() {
//   return (
//     <div className="clients-section">
//       <h2 style={{ color: "white", textAlign: "center" }}>Our Clients</h2>
//       <div className="clients-container">
//         <div className="client-box" data-aos="fade-up">
//           <h3>Trendy Gadgets</h3>
//           <p>FullStack Commercial Ecommerce Website (MERNSTACK)</p>
//           <a
//             href="https://trendygadgetske.com/"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             Read more &rarr;
//           </a>
//         </div>
//         <div className="client-box" data-aos="fade-up">
//           <h3>Gym Classic</h3>
//           <p>Health and Fitness Mobile Application</p>
//           <a
//             href="https://play.google.com/store/apps/details?id=com.gymclassic"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             Read more &rarr;
//           </a>
//         </div>
//         <div className="client-box" data-aos="fade-up">
//           <h3>GCI Church</h3>
//           <p>Church website with Members Portal</p>
//           <a
//             href="https://gci-kutus.vercel.app/"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             Read more &rarr;
//           </a>
//         </div>
//         <div className="client-box" data-aos="fade-up">
//           <h3>Jagaad</h3>
//           <p>E-Commerce Website and NFT Marketplace</p>
//           <a
//             href="https://loquacious-cendol-fff34b.netlify.app/"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             Read more &rarr;
//           </a>
//         </div>
//         <div className="client-box" data-aos="fade-up">
//           <h3>Trend Spot</h3>
//           <p>E-Commerce Website Specializing in Clothline and Shoes</p>
//           <a
//             href="https://spottrend-nine.vercel.app"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             Read more &rarr;
//           </a>
//         </div>
//         <div className="client-box" data-aos="fade-up">
//           <h3>Nairobi Cleaning and Fumigation Services</h3>
//           <p>Cleaning anf Fumigation Company</p>
//           <a
//             href="https://user-psi.vercel.app/"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             Read more &rarr;
//           </a>
//         </div>
//       </div>
//       <ChatBot />
//     </div>
//   );
// }

// export default Clients;


import React, { useState, useEffect, useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { 
  Float, 
  Text, 
  Html, 
  OrbitControls,
  Stars,
  Environment,
  MeshWobbleMaterial
} from "@react-three/drei";
import * as THREE from "three";
import AOS from "aos";
import "aos/dist/aos.css";
import "../Styles/Clients.css";
import ChatBot from "./ChatBot";
import {
  AiOutlineRocket,
  AiOutlineGlobal,
  AiOutlineStar,
  AiOutlineArrowRight,
  AiOutlineEye,
  AiOutlineCode,
  AiOutlineMobile,
  AiOutlineCloudServer,
  AiOutlineCheckCircle,
  AiOutlineLineChart
} from "react-icons/ai";
import {
  FaExternalLinkAlt,
  FaRegHeart,
  FaRegLightbulb,
  FaRegClock,
  FaChartLine,
  FaUsers,
  FaShieldAlt
} from "react-icons/fa";
import { TbWorld } from "react-icons/tb";

// 3D Client Orb Component
function ClientOrb({ client, index, activeClient, setActiveClient }) {
  const meshRef = useRef();
  const [hovered, setHovered] = useState(false);
  
  useFrame((state) => {
    if (meshRef.current) {
      // Subtle floating animation
      meshRef.current.position.y = Math.sin(state.clock.elapsedTime * 0.5 + index) * 0.1;
      
      // Rotation
      meshRef.current.rotation.x = Math.sin(state.clock.elapsedTime * 0.3 + index) * 0.1;
      meshRef.current.rotation.y = Math.cos(state.clock.elapsedTime * 0.2 + index) * 0.1;
      
      // Scale effect when active or hovered
      const targetScale = activeClient === index || hovered ? 1.2 : 1;
      meshRef.current.scale.lerp(
        new THREE.Vector3(targetScale, targetScale, targetScale),
        0.1
      );
    }
  });

  const getTechColor = (tech) => {
    const colors = {
      'MERN': '#00d8ff',
      'React': '#61dafb',
      'Node.js': '#68a063',
      'Mobile': '#ff6b6b',
      'E-commerce': '#ffa502',
      'Blockchain': '#8e44ad',
      'Cloud': '#3498db',
      'AI/ML': '#9b59b6'
    };
    return colors[tech] || '#6366f1';
  };

  return (
    <Float
      speed={2}
      rotationIntensity={0.5}
      floatIntensity={1}
    >
      <mesh
        ref={meshRef}
        position={[
          Math.cos((index / 6) * Math.PI * 2) * 3,
          Math.sin((index / 6) * Math.PI * 2) * 1.5,
          0
        ]}
        onPointerOver={() => setHovered(true)}
        onPointerOut={() => setHovered(false)}
        onClick={() => setActiveClient(index)}
      >
        <icosahedronGeometry args={[0.5, 1]} />
        <MeshWobbleMaterial
          color={client.color}
          emissive={client.color}
          emissiveIntensity={hovered ? 0.8 : 0.3}
          metalness={0.9}
          roughness={0.1}
          speed={hovered ? 2 : 0.5}
          factor={hovered ? 0.2 : 0.1}
        />
        
        {/* Glow effect */}
        {hovered && (
          <mesh position={[0, 0, 0]}>
            <sphereGeometry args={[0.7, 16, 16]} />
            <meshBasicMaterial
              color={client.color}
              transparent
              opacity={0.2}
              side={THREE.BackSide}
            />
          </mesh>
        )}
      </mesh>

      {/* Label */}
      <Html
        position={[
          Math.cos((index / 6) * Math.PI * 2) * 3,
          Math.sin((index / 6) * Math.PI * 2) * 1.5 - 1,
          0
        ]}
        center
      >
        <div className={`client-label ${hovered ? 'hovered' : ''}`}>
          {client.name}
        </div>
      </Html>

      {/* Tech indicators */}
      <Html
        position={[
          Math.cos((index / 6) * Math.PI * 2) * 3,
          Math.sin((index / 6) * Math.PI * 2) * 1.5 + 0.8,
          0
        ]}
        center
      >
        <div className="tech-tags">
          {client.technologies.slice(0, 2).map((tech, i) => (
            <span 
              key={i} 
              className="tech-tag"
              style={{ backgroundColor: getTechColor(tech) }}
            >
              {tech}
            </span>
          ))}
        </div>
      </Html>
    </Float>
  );
}

// Main 3D Scene for Clients
function ClientsScene({ clients, activeClient, setActiveClient }) {
  return (
    <Canvas camera={{ position: [0, 0, 8], fov: 60 }}>
      <ambientLight intensity={0.5} />
      <pointLight position={[10, 10, 10]} intensity={1} color="#6366f1" />
      <pointLight position={[-10, -10, -10]} intensity={0.5} color="#8b5cf6" />
      
      <Stars
        radius={100}
        depth={50}
        count={5000}
        factor={4}
        saturation={0}
        fade
      />
      
      {/* Central light source */}
      <mesh position={[0, 0, 0]}>
        <sphereGeometry args={[0.3, 32, 32]} />
        <meshBasicMaterial color="#6366f1" />
      </mesh>
      
      {/* Connection lines */}
      {clients.map((client, index) => (
        <line key={`line-${index}`}>
          <bufferGeometry attach="geometry">
            <float32BufferAttribute
              attach="attributes-position"
              args={[
                new Float32Array([
                  0, 0, 0,
                  Math.cos((index / 6) * Math.PI * 2) * 3,
                  Math.sin((index / 6) * Math.PI * 2) * 1.5,
                  0
                ]), 
                3
              ]}
            />
          </bufferGeometry>
          <lineBasicMaterial
            color={client.color}
            transparent
            opacity={activeClient === index ? 0.8 : 0.2}
            linewidth={activeClient === index ? 3 : 1}
          />
        </line>
      ))}
      
      {/* Client orbs */}
      {clients.map((client, index) => (
        <ClientOrb
          key={index}
          client={client}
          index={index}
          activeClient={activeClient}
          setActiveClient={setActiveClient}
        />
      ))}
      
      <OrbitControls
        enableZoom={true}
        enablePan={true}
        enableRotate={true}
        autoRotate={true}
        autoRotateSpeed={0.5}
        minDistance={5}
        maxDistance={15}
      />
      <Environment preset="city" />
    </Canvas>
  );
}

function Clients() {
  const [activeClient, setActiveClient] = useState(0);
  const [stats, setStats] = useState({
    projects: 0,
    clients: 0,
    satisfaction: 0,
    technologies: 0
  });

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });

    // Animate stats
    const timer = setTimeout(() => {
      setStats({
        projects: 50,
        clients: 30,
        satisfaction: 98,
        technologies: 15
      });
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const clients = [
    {
      name: "Trendy Gadgets",
      description: "FullStack Commercial E-commerce Website with advanced features including real-time inventory management, AI-powered recommendations, and secure payment processing.",
      longDescription: "A comprehensive e-commerce solution built with MERN stack featuring real-time analytics, multi-vendor support, advanced search functionality, and seamless integration with multiple payment gateways and shipping providers.",
      technologies: ["MERN", "React", "Node.js", "E-commerce", "AI/ML"],
      link: "https://trendygadgetske.com/",
      industry: "E-commerce",
      timeline: "3 months",
      teamSize: "5 developers",
      color: "#00d8ff",
      logo: "🛒",
      impact: "Increased sales by 240%",
      features: ["Real-time analytics", "AI recommendations", "Mobile responsive", "Multi-vendor"]
    },
    {
      name: "Gym Classic",
      description: "Health and Fitness Mobile Application with workout tracking, nutrition planning, and social features for fitness communities.",
      longDescription: "A cross-platform mobile application that combines workout tracking, personalized nutrition plans, progress analytics, and social features to create an engaging fitness community. Includes AI-powered workout recommendations.",
      technologies: ["Mobile", "React Native", "Firebase", "AI/ML"],
      link: "https://play.google.com/store/apps/details?id=com.gymclassic",
      industry: "Health & Fitness",
      timeline: "4 months",
      teamSize: "4 developers",
      color: "#ff6b6b",
      logo: "💪",
      impact: "50,000+ downloads",
      features: ["Workout tracking", "Nutrition plans", "Progress analytics", "Social features"]
    },
    {
      name: "GCI Church",
      description: "Church website with comprehensive Members Portal, event management, donations, and community engagement features.",
      longDescription: "A modern church management platform featuring member directories, event scheduling, online donations, sermon archives, and real-time communication tools to enhance community engagement and spiritual growth.",
      technologies: ["React", "Node.js", "MongoDB", "Cloud"],
      link: "https://gci-kutus.vercel.app/",
      industry: "Religious",
      timeline: "2 months",
      teamSize: "3 developers",
      color: "#3498db",
      logo: "⛪",
      impact: "300% engagement increase",
      features: ["Member portal", "Event management", "Online donations", "Sermon library"]
    },
    {
      name: "Jagaad",
      description: "E-Commerce Website integrated with NFT Marketplace, enabling digital asset trading alongside physical products.",
      longDescription: "A hybrid platform combining traditional e-commerce with blockchain technology, featuring an integrated NFT marketplace, wallet integration, and seamless transactions between physical and digital goods.",
      technologies: ["MERN", "Blockchain", "Web3", "E-commerce"],
      link: "https://loquacious-cendol-fff34b.netlify.app/",
      industry: "E-commerce & Blockchain",
      timeline: "5 months",
      teamSize: "6 developers",
      color: "#8e44ad",
      logo: "🛍️",
      impact: "First hybrid platform in region",
      features: ["NFT marketplace", "Wallet integration", "Hybrid transactions", "Blockchain"]
    },
    {
      name: "Trend Spot",
      description: "Specialized E-Commerce Website focusing on clothing and footwear with virtual try-on features and AR integration.",
      longDescription: "A fashion-forward e-commerce platform featuring virtual try-on using AR technology, size recommendation algorithms, and a personalized shopping experience with style recommendations based on user preferences.",
      technologies: ["React", "AR", "E-commerce", "AI/ML"],
      link: "https://spottrend-nine.vercel.app",
      industry: "Fashion Retail",
      timeline: "3.5 months",
      teamSize: "4 developers",
      color: "#ffa502",
      logo: "👟",
      impact: "Reduced returns by 60%",
      features: ["Virtual try-on", "AR integration", "Size recommendations", "Style AI"]
    },
    {
      name: "Nairobi Cleaning",
      description: "Cleaning and Fumigation Services platform with booking system, service tracking, and customer management.",
      longDescription: "A comprehensive service platform for cleaning and fumigation companies featuring online booking, real-time service tracking, customer management, automated scheduling, and integrated payment solutions.",
      technologies: ["React", "Node.js", "Mobile", "Cloud"],
      link: "https://user-psi.vercel.app/",
      industry: "Services",
      timeline: "2.5 months",
      teamSize: "3 developers",
      color: "#2ecc71",
      logo: "✨",
      impact: "Increased bookings by 180%",
      features: ["Online booking", "Service tracking", "Customer portal", "Payment system"]
    }
  ];

  const clientStats = [
    { icon: <AiOutlineRocket />, value: `${stats.projects}+`, label: "Projects Delivered", color: "#6366f1" },
    { icon: <FaUsers />, value: `${stats.clients}+`, label: "Satisfied Clients", color: "#10b981" },
    { icon: <AiOutlineStar />, value: `${stats.satisfaction}%`, label: "Satisfaction Rate", color: "#f59e0b" },
    { icon: <AiOutlineCode />, value: `${stats.technologies}+`, label: "Technologies Used", color: "#8b5cf6" }
  ];

  const industries = [
    { name: "E-commerce", count: 12, color: "#00d8ff" },
    { name: "Health & Fitness", count: 8, color: "#ff6b6b" },
    { name: "FinTech", count: 6, color: "#2ecc71" },
    { name: "Education", count: 5, color: "#9b59b6" },
    { name: "Services", count: 7, color: "#3498db" },
    { name: "Social", count: 4, color: "#e74c3c" }
  ];

  return (
    <div className="clients-container">
      {/* Hero Section */}
      <section className="clients-hero">
        <div className="hero-background">
          <div className="hero-glow"></div>
          <div className="hero-grid"></div>
          <div className="hero-particles">
            {[...Array(20)].map((_, i) => (
              <div key={i} className="particle" style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`,
                width: `${Math.random() * 4 + 2}px`,
                height: `${Math.random() * 4 + 2}px`,
              }}></div>
            ))}
          </div>
        </div>

        <div className="hero-content">
          <div data-aos="fade-up" className="hero-text">
            <div className="hero-badge">
              <AiOutlineGlobal />
              <span>Global Success Stories</span>
            </div>
            
            <h1 className="hero-title">
              <span className="gradient-text">Innovation</span>
              <span className="hero-title-accent"> that Delivers</span>
            </h1>
            
            <p className="hero-description">
              Discover how we've transformed businesses across industries with 
              cutting-edge technology solutions and unparalleled expertise.
            </p>
          </div>

          {/* Stats */}
          <div data-aos="fade-up" data-aos-delay="300" className="stats-grid">
            {clientStats.map((stat, index) => (
              <div key={index} className="stat-card">
                <div className="stat-icon" style={{ color: stat.color }}>
                  {stat.icon}
                </div>
                <div className="stat-content">
                  <h3 className="stat-value">{stat.value}</h3>
                  <p className="stat-label">{stat.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 3D Interactive Clients Visualization */}
      <section className="clients-visualization">
        <div className="container">
          <div data-aos="fade-up" className="section-header">
            <h2>
              Our <span className="gradient-text">Global</span> Portfolio
            </h2>
            <p>Interactive 3D visualization of our client ecosystem</p>
          </div>
          
          <div className="visualization-wrapper">
            <div className="visualization-canvas">
              <ClientsScene 
                clients={clients} 
                activeClient={activeClient}
                setActiveClient={setActiveClient}
              />
              
              <div className="visualization-controls">
                <div className="control-hint">
                  <AiOutlineEye />
                  <span>Click on any sphere to select</span>
                </div>
                <div className="control-hint">
                  <TbWorld />
                  <span>Drag to rotate the view</span>
                </div>
              </div>
            </div>

            {/* Active Client Details */}
            <div data-aos="fade-left" className="client-details">
              <div className="client-details-header">
                <div className="client-logo-large">
                  {clients[activeClient].logo}
                </div>
                <div className="client-title">
                  <h3>{clients[activeClient].name}</h3>
                  <span className="client-industry">{clients[activeClient].industry}</span>
                </div>
              </div>
              
              <div className="client-description">
                <p>{clients[activeClient].longDescription}</p>
              </div>
              
              <div className="client-metrics">
                <div className="metric">
                  <FaRegClock />
                  <div>
                    <span className="metric-value">{clients[activeClient].timeline}</span>
                    <span className="metric-label">Development Time</span>
                  </div>
                </div>
                <div className="metric">
                  <FaUsers />
                  <div>
                    <span className="metric-value">{clients[activeClient].teamSize}</span>
                    <span className="metric-label">Team Size</span>
                  </div>
                </div>
                <div className="metric">
                  <FaChartLine />
                  <div>
                    <span className="metric-value">{clients[activeClient].impact}</span>
                    <span className="metric-label">Business Impact</span>
                  </div>
                </div>
              </div>
              
              <div className="client-features">
                <h4>Key Features</h4>
                <div className="features-grid">
                  {clients[activeClient].features.map((feature, idx) => (
                    <div key={idx} className="feature-tag">
                      <AiOutlineCheckCircle />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
              
              <div className="client-technologies">
                <h4>Technologies Used</h4>
                <div className="tech-grid">
                  {clients[activeClient].technologies.map((tech, idx) => (
                    <span key={idx} className="tech-badge">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
              
              <div className="client-actions">
                <a
                  href={clients[activeClient].link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary btn-glow"
                >
                  <AiOutlineEye />
                  <span>View Live Project</span>
                  <FaExternalLinkAlt />
                </a>
                <button className="btn-secondary">
                  <FaRegHeart />
                  <span>Case Study</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* All Clients Grid */}
      <section className="all-clients-section">
        <div className="container">
          <div data-aos="fade-up" className="section-header">
            <h2>
              Complete <span className="gradient-text">Client</span> Portfolio
            </h2>
            <p>Browse through all our successful client projects</p>
          </div>
          
          <div className="clients-grid">
            {clients.map((client, index) => (
              <div
                key={index}
                data-aos="fade-up"
                data-aos-delay={index * 100}
                className={`client-card ${activeClient === index ? 'active' : ''}`}
                onClick={() => setActiveClient(index)}
              >
                <div className="client-card-inner">
                  <div className="client-card-header">
                    <div className="client-logo" style={{ backgroundColor: client.color }}>
                      {client.logo}
                    </div>
                    <div className="client-info">
                      <h3>{client.name}</h3>
                      <span className="client-industry-tag">{client.industry}</span>
                    </div>
                  </div>
                  
                  <p className="client-card-description">{client.description}</p>
                  
                  <div className="client-tech-stack">
                    {client.technologies.slice(0, 3).map((tech, idx) => (
                      <span key={idx} className="tech-chip">
                        {tech}
                      </span>
                    ))}
                    {client.technologies.length > 3 && (
                      <span className="tech-more">+{client.technologies.length - 3}</span>
                    )}
                  </div>
                  
                  <div className="client-card-footer">
                    <a
                      href={client.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="client-link"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <AiOutlineEye />
                      <span>View Project</span>
                    </a>
                    <div className="client-impact">
                      <AiOutlineLineChart />
                      <span>{client.impact}</span>
                    </div>
                  </div>
                  
                  <div className="client-card-hover">
                    <AiOutlineArrowRight />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries We Serve */}
      <section className="industries-section">
        <div className="container">
          <div data-aos="fade-up" className="section-header">
            <h2>
              Industries <span className="gradient-text">Transformed</span>
            </h2>
            <p>We deliver solutions across diverse business domains</p>
          </div>
          
          <div className="industries-grid">
            {industries.map((industry, index) => (
              <div
                key={index}
                data-aos="fade-up"
                data-aos-delay={index * 100}
                className="industry-card"
              >
                <div 
                  className="industry-icon"
                  style={{ backgroundColor: industry.color + '20' }}
                >
                  <div 
                    className="industry-icon-inner"
                    style={{ color: industry.color }}
                  >
                    {index === 0 && <AiOutlineMobile />}
                    {index === 1 && <FaRegHeart />}
                    {index === 2 && <FaShieldAlt />}
                    {index === 3 && <FaRegLightbulb />}
                    {index === 4 && <AiOutlineCloudServer />}
                    {index === 5 && <FaUsers />}
                  </div>
                </div>
                
                <div className="industry-content">
                  <h3>{industry.name}</h3>
                  <p className="industry-count">{industry.count} projects</p>
                  <div className="industry-progress">
                    <div 
                      className="industry-progress-bar"
                      style={{ 
                        width: `${(industry.count / 12) * 100}%`,
                        backgroundColor: industry.color
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="clients-cta">
        <div className="container">
          <div data-aos="fade-up" className="cta-content">
            <div className="cta-glow"></div>
            <h2>Ready to Join Our Success Stories?</h2>
            <p>Let's build something amazing together. Your success is our priority.</p>
            <div className="cta-buttons">
              <a href="/contact" className="btn-primary btn-glow">
                <span>Start Your Project</span>
                <AiOutlineArrowRight />
              </a>
              <a href="/services" className="btn-secondary">
                <span>Explore Our Services</span>
              </a>
            </div>
            <div className="cta-stats">
              <div className="cta-stat">
                <AiOutlineCheckCircle />
                <span>Free Consultation</span>
              </div>
              <div className="cta-stat">
                <FaRegClock />
                <span>24/7 Support</span>
              </div>
              <div className="cta-stat">
                <FaShieldAlt />
                <span>100% Satisfaction</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ChatBot />
    </div>
  );
}

export default Clients;